export default function WarningCircleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4002 19L11.0002 3.1L2.60021 19H19.4002ZM10.1002 0.6C10.3002 0.2 10.6002 0 11.0002 0C11.3002 0 11.7002 0.2 11.9002 0.6L21.9002 19.5C22.3002 20.2 21.8002 21 21.0002 21H1.10021C0.300207 21 -0.199793 20.2 0.100207 19.4L10.1002 0.6ZM12.0002 8H10.0002V13H12.0002V8ZM10.0002 17H12.0002V15H10.0002V17Z"
        fill="currentColor"
      />
    </svg>
  );
}
